import { changeAddressClick } from '../../../state/helpers';
import { useGlobalState } from '../../../state/state';

import { IWTButton } from '../IWTButton';

export const ChangeAddressIWT = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const renderChangeAddress = !membershipDetails?.loggedInMember?.secured;

  return renderChangeAddress ? (
    <IWTButton title="Change address" id="ChangeAddressIWT" onClick={changeAddressClick} />
  ) : (
    <></>
  );
};
